import {route} from "../route";
import {modelHydrator} from "./_modelHydrator";
import {circuitHydrator} from "./circuitHydrator";
import {routeResultType} from "../../types/Api/RouteResultType";

export const routeHydrator = {
  hydrate: (route: routeResultType): route => {
    return Object.assign({
      routeId: route.routeId,
      circuit: route.circuit === null ? undefined : circuitHydrator.hydrate(route.circuit),
      meetHour: route.meetHour,
      meetPlace: route.meetPlace,
      rideDate: route.rideDate,
      startHour: route.startHour,
    }, modelHydrator.hydrate(route))
  }
}